module.exports = __webpack_public_path__ + "img/macbook.8f8ffbe2.png";